import { configureStore } from "@reduxjs/toolkit";
import usersEarlyAccessRegistrationSlice from "../slice/usersEarlyAccessRegistration";
import advertSlice from "../slice/advertSlice"

export const store = configureStore({
    reducer: {
      users: usersEarlyAccessRegistrationSlice,  
      advert: advertSlice,
    },
  });
